import { render, staticRenderFns } from "./CreateTemplatesV2.vue?vue&type=template&id=52fff53d"
import script from "./CreateTemplatesV2.vue?vue&type=script&lang=js"
export * from "./CreateTemplatesV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports